import { Menu, LogOut, User } from 'lucide-react'
import { Button, ThemeToggle } from '@/components/ui'

interface HeaderProps {
  onMenuClick?: () => void
  showMenuButton?: boolean
  user?: {
    name: string
    email: string
  } | null
  onLogout?: () => void
}

export function Header({ onMenuClick, showMenuButton = true, user, onLogout }: HeaderProps) {
  return (
    <header className="sticky top-0 z-40 bg-white dark:bg-slate-800 border-b border-slate-200 dark:border-slate-700">
      <div className="flex items-center justify-between h-16 px-4">
        {/* Left side */}
        <div className="flex items-center gap-4">
          {showMenuButton && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onMenuClick}
              className="lg:hidden"
              aria-label="Toggle menu"
            >
              <Menu className="h-5 w-5" />
            </Button>
          )}
          <div className="flex items-center gap-3">
            <img
              src="/logo.svg"
              alt="PBS SoCal"
              className="h-8 dark:hidden"
            />
            <img
              src="/logo-dark.svg"
              alt="PBS SoCal"
              className="h-8 hidden dark:block"
            />
            <span className="font-semibold text-slate-900 dark:text-white hidden sm:block">
              Data Platform
            </span>
          </div>
        </div>

        {/* Right side */}
        <div className="flex items-center gap-2">
          <ThemeToggle />

          {user && (
            <div className="flex items-center gap-2">
              <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-md bg-slate-100 dark:bg-slate-700">
                <User className="h-4 w-4 text-slate-500 dark:text-slate-400" />
                <span className="text-sm text-slate-700 dark:text-slate-300">
                  {user.name}
                </span>
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={onLogout}
                aria-label="Logout"
                title="Logout"
              >
                <LogOut className="h-5 w-5" />
              </Button>
            </div>
          )}
        </div>
      </div>
    </header>
  )
}
